import { render, staticRenderFns } from "./BlwDocument.vue?vue&type=template&id=44cb5005&"
import script from "./BlwDocument.vue?vue&type=script&lang=js&"
export * from "./BlwDocument.vue?vue&type=script&lang=js&"
import style0 from "./BlwDocument.vue?vue&type=style&index=0&id=44cb5005&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports